$(document).on("click", ".property-close button", function(){
    $(this).closest('.property').remove();
});